export const STEPS = {
  REASON_SELECTION: 1,
  USAGE_STATS: 2,
  CONFIRM_CANCELLATION: 3,
};

export const CANCEL_SUBSCRIPTION_REASON = {
  NO_NEED: 'NO_NEED',
  MISSING_FEATURE: 'MISSING_FEATURE',
  USE_OTHER_SERVICE: 'USE_OTHER_SERVICE',
  NOT_SOLVING_PROBLEM: 'NOT_SOLVING_PROBLEM',
  TEMPORARY_CANCEL: 'TEMPORARY_CANCEL',
  TOO_EXPENSIVE: 'TOO_EXPENSIVE',
  OTHER: 'OTHER',
};

export const CANCEL_REASONS = [
  {
    key: CANCEL_SUBSCRIPTION_REASON.NO_NEED,
    labelKey: 'cancelReasonNoNeed',
  },
  {
    key: CANCEL_SUBSCRIPTION_REASON.MISSING_FEATURE,
    labelKey: 'cancelReasonMissingFeature',
  },
  {
    key: CANCEL_SUBSCRIPTION_REASON.USE_OTHER_SERVICE,
    labelKey: 'cancelReasonUseCompetitor',
  },
  {
    key: CANCEL_SUBSCRIPTION_REASON.NOT_SOLVING_PROBLEM,
    labelKey: 'cancelReasonNotSolveProblem',
  },
  {
    key: CANCEL_SUBSCRIPTION_REASON.TEMPORARY_CANCEL,
    labelKey: 'cancelReasonTemporaryCancel',
  },
  {
    key: CANCEL_SUBSCRIPTION_REASON.TOO_EXPENSIVE,
    labelKey: 'cancelReasonTooExpensive',
  },
  {
    key: CANCEL_SUBSCRIPTION_REASON.OTHER,
    labelKey: 'cancelReasonOther',
  },
];

export const OTHER_REASON_KEY = CANCEL_SUBSCRIPTION_REASON.OTHER;
export const MAX_TEXT_LENGTH = 1000;
